import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoginService } from '@shared-angular/services/login.service';
import { RouteShareService } from '../../services/route-share.service';
import { TrunkService } from '../../services/trunk.service';

export const datatrunkResolver: ResolveFn<boolean> = async (route, _state) => {
  const loginService: LoginService = inject(LoginService);
  const trunkService: TrunkService = inject(TrunkService);
  const rss: RouteShareService = inject(RouteShareService);
  const user = await loginService.loadMyUser();

  if (user == null) {
    return false;
  }
  const id = route.parent?.params['id'] as string;

  rss.datatrunks = (await trunkService.getTrunks(id)).trunks.reverse();
  const trunkid = route.firstChild?.params['trunkid'] as string;
  if (trunkid) {
    rss.datatrunk = rss.datatrunks.find(trunk => trunk._id === trunkid);
  } else {
    rss.datatrunk = undefined;
  }
  return true;
};
